import { AccountPageLayout, AccountSettings, Title } from '@bpm-web-app/components';

export function AccountSettingsPage({ title }: { title: string }) {
    return (
        <>
            <Title platform="create" title={title} />
            <AccountPageLayout isCreate>
                <AccountSettings isCreate />
            </AccountPageLayout>
        </>
    );
}

export default AccountSettingsPage;

export async function getStaticProps() {
    return {
        props: {
            title: 'Account Settings'
        }
    };
}
